import React from 'react'
import { InvoiceDocument, PDFViewer } from 'components'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import * as moment from 'moment-timezone'

const useStyles = makeStyles({
  viewInvoiceBody: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
})

const InvoiceDocumentView = ({ invoice, timezone = moment.tz.guess() }) => {
  const classes = useStyles()
  const currentUser = useSelector(state => state.auth.currentUser)
  const isAccountant = currentUser?.subrole === 'accountant'

  return (
    <div className={classes.viewInvoiceBody}>
      <div>
        <div id="invoice">
          {invoice.uuid && (
            <PDFViewer
              document={<InvoiceDocument timezone={timezone} invoice={invoice} isAccountant={isAccountant} />}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default InvoiceDocumentView
